import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import helpers from "utils/helpers";

const pickerClasses = [
  "cursor-pointer",
  "bg-calendar",
  "bg-[right_10px_top_10px]",
  "bg-[length:18px_18px]",
  "bg-no-repeat",
  "flex",
  "flex-row-reverse",
  "border",
  "outline-none",
  "text-gray-900",
  "text-sm",
  "rounded-lg",
  "block",
  "w-full",
  "p-2",
  "dark:bg-gray-700",
  "dark:border-gray-600",
  "dark:placeholder-gray-400",
  "dark:text-white",
  "dark:focus:ring-blue-500",
  "dark:focus:border-blue-500",
];

const ODateRangePicker = (props) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(props.startDate || "");
  const [endDate, setEndDate] = useState(props.endDate || "");
  const [durationTime, setDurationTime] = useState("");

  // Sync with props when they change
  useEffect(() => {
    if (props.startDate !== undefined && props.startDate !== null) {
      setStartDate(props.startDate);
    }
  }, [props.startDate]);

  useEffect(() => {
    if (props.endDate !== undefined && props.endDate !== null) {
      setEndDate(props.endDate);
    }
  }, [props.endDate]);

  // Handle reset from parent
  useEffect(() => {
    if (props?.isReset) {
      setStartDate("");
      setEndDate("");
      props?.setIsReset(false);
    }
  }, [props?.isReset]);

  const onChangeStartDate = ([date]) => {
    setStartDate(date);
    if (props.duration === "Weekly") {
      setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 6)));
    } else if (props.duration === "Fortnight") {
      setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 14)));
    } else {
      setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 30)));
    }
    props?.handleDateChange(date, endDate);
  };

  const onChangeEndDate = ([date]) => {
    setEndDate(date);
    props.handleDateChange(startDate, date);
  };

  return (
    <>
      <div className="relative flex items-center mb-3">
        <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_FROM")}</label>
        <Flatpickr
          className={pickerClasses.join(" ")}
          name="start_date"
          placeholder={t("O_START_DATE")}
          value={startDate}
          disabled={props?.isDate && !props?.duration}
          options={{
            maxDate: props?.isDate ? new Date() : endDate,
            dateFormat: "m-d-Y",
          }}
          onChange={onChangeStartDate}
        />
      </div>
      <div className="relative flex items-center mb-3">
        <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_TO")}</label>
        <Flatpickr
          className={pickerClasses.join(" ")}
          name="end_date"
          placeholder={t("O_END_DATE")}
          value={endDate}
          disabled={props?.isDate && !startDate}
          options={{
            minDate: helpers?.ternaryCondition(props?.isDate, startDate ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)) : "", startDate),
            maxDate: helpers?.ternaryCondition(props?.isDate, new Date(durationTime) > new Date() ? new Date() : durationTime, ""),
            dateFormat: "m-d-Y",
          }}
          onChange={onChangeEndDate}
        />
      </div>
    </>
  );
};

export default ODateRangePicker;





// import Flatpickr from "react-flatpickr";
// import "flatpickr/dist/themes/material_blue.css";
// import { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import helpers from "utils/helpers";
// const pickerClasses = [
//   "cursor-pointer",
//   "bg-calendar",
//   "bg-[right_10px_top_10px]",
//   "bg-[length:18px_18px]",
//   "bg-no-repeat",
//   "flex",
//   "flex-row-reverse",
//   "border",
//   "outline-none",
//   "text-gray-900",
//   "text-sm",
//   "rounded-lg",
//   "block",
//   "w-full",
//   "p-2",
//   "dark:bg-gray-700",
//   "dark:border-gray-600",
//   "dark:placeholder-gray-400",
//   "dark:text-white",
//   "dark:focus:ring-blue-500",
//   "dark:focus:border-blue-500",
// ];
// const ODateRangePicker = (props) => {
//   const { t } = useTranslation();
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [durationTime, setDurationTime] = useState("");

//   const onChangeStartDate = ([date]) => {
//     setStartDate(date);
//     if (props.duration === "Weekly") {
//       setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 6)));
//     } else if (props.duration === "Fortnight") {
//       setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 14)));
//     } else {
//       setDurationTime(new Date(new Date(date).setDate(new Date(date).getDate() + 30)));
//     }
//     props?.handleDateChange(date, endDate);
//   };
//   const onChangeEndDate = ([date]) => {
//     setEndDate(date);
//     props.handleDateChange(startDate, date);
//   };
//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//   };

//   useEffect(() => {
//     handleReset();
//     if (props?.isReset) {
//       props?.setIsReset(false);
//     }
//   }, [props?.isReset]);

//   return (
//     // <div className='sm:flex items-center text-center sm:text-left px-3 md:px-4 xl:px-7 lg:px-5  md:py-5 py-4 md:py-8 border'>
//     <>
//       <div className=" relative flex items-center mb-3">
//         <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_FROM")}</label>
//         <Flatpickr
//           className={pickerClasses.join(" ")}
//           name="start_date"
//           placeholder={t("O_START_DATE")}
//           value={startDate}
//           disabled={props?.isDate && !props?.duration}
//           options={{
//             maxDate: props?.isDate ? new Date() : endDate,
//             dateFormat: "m-d-Y",
//           }}
//           onChange={onChangeStartDate}
//         />
//       </div>
//       <div className="relative flex items-center mb-3">
//         <label className="mx-2 text-[#B8BBBF] text-xs whitespace-nowrap">{t("O_TO")}</label>
//         <Flatpickr
//           className={pickerClasses.join(" ")}
//           name="end_date"
//           placeholder={t("O_END_DATE")}
//           value={endDate}
//           disabled={props?.isDate && !startDate}
//           options={{
//             minDate: helpers?.ternaryCondition(props?.isDate, startDate ? new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)) : "", startDate),
//             maxDate: helpers?.ternaryCondition(props?.isDate, new Date(durationTime) > new Date() ? new Date() : durationTime, ""),
//             dateFormat: "m-d-Y",
//           }}
//           onChange={onChangeEndDate}
//         />
//       </div>
//     </>
//     // </div>
//   );
// };

// export default ODateRangePicker;
